import { Image, StyleSheet, View } from '@react-pdf/renderer';
import React from 'react';

const styles = StyleSheet.create({
  position: {
    position: 'absolute',
    left: '654px',
    top: '393px',
    width: '108px',
    height: '108px',
  },
  base64Top: { position: 'absolute', width: '100%', height: '100%' },
  base64Bottom: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '6px',
  },
});

interface Props {
  topLogoBase64: string;
  bottomLogoBase64: string;
}

export default function LogoText(props: Readonly<Props>) {
  const { topLogoBase64, bottomLogoBase64 } = props;
  return (
    <View style={styles.position}>
      <Image style={styles.base64Top} src={topLogoBase64} />
      <Image style={styles.base64Bottom} src={bottomLogoBase64} />
    </View>
  );
}
